module.exports = __webpack_public_path__ + "static/media/JuventusBlack.d3d6dc98.png";